export const sloganData = {
  contactText: "Deixe seus dados e conheça um atendimento personalizado",
  slogan:
    "Muito mais que um serviço de Contabilidade, oferecemos atendimento personalizado de acordo com a necessidade singular de cada cliente.",
}
